<template>
  <div class="history">
    <div class="row mt-5 mb-5">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Reporte de compras</h5>
            <!-- {{user}} -->
            <!-- <pre>
              {{items}}
            </pre> -->
            <div class="row justify-content-end" v-if="selected.length > 0">
              <!-- <button class="btn btn-purple" @click="printEtiquetas">Imprimir etiquetas</button> -->
              <button class="btn btn-danger" @click="printEtiquetas2">Imprimir etiquetas</button>
            </div>
            <div class="row justify-content-center mt-5 mb-4">
              <input type="date" v-model="dateI" name="fechaInicial">
              <input type="date" v-model="dateF" name="fechaFinal" class="mt-1 ml-2">
              <button class="btn btn-secondary ml-3" @click="getCompras">Buscar</button>
            </div>
            <!-- {{selected}} -->
             <!-- {{ items[0].date }} -->
            <!-- <b-table
              selectable
              class="table-adelantazo"
              :select-mode="selectMode"
              responsive="sm"
              ref="selectableTable"
              @row-selected="onRowSelected"
              selectedVariant="success"
              show-empty
              stacked="md"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <template v-slot:cell(amount)="row">
                <div align="center" class="history-amount">
                  <span v-html="getFormattedAmount(row.item)" />
                </div>
              </template>
              <template v-slot:cell(action)="row">
                <div align="center" class="history-amount">
                    <button class="btn btn-purple" @click="showDetail(row)">Detalle</button>
                </div>
              </template>
              <template #cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                  <span aria-hidden="true">&check;</span>
                  <span class="sr-only">Selected</span>
                </template>
                <template v-else>
                  <span aria-hidden="true">&nbsp;</span>
                  <span class="sr-only">Not selected</span>
                </template>
              </template>
            </b-table> -->
            <div class="row justify-content-end mb-4">
              <jsonExcel :data="items"
                class="btn btn-secondary"
                :fields= "{
                  'Folio': 'id_buy',
                  'Proveedor': 'provider',
                  'Registro': 'name',
                  'Productos': 'quantity_products',
                  'Total de compra': 'amount',
                  'Fecha de compra': 'date',
                }"
                worksheet="Reporte de compra"
                name="Reporte de compra.xls"
              >
                Descargar a Excel
              </jsonExcel>
            </div>
            <vue-good-table
              @on-selected-rows-change="onRowSelected"
              :columns="columns"
              :rows="items"
              ref="my-table"
              :totalRows="totalRecords"
              :isLoading.sync="isLoading"
              styleClass="vgt-table bordered"
              :pagination-options="{
                  enabled: true,
                  mode: 'registros',
                  position: 'top',
                  perPage: 10,
                  nextLabel: 'siguiente',
                  prevLabel: 'anterior',
                  rowsPerPageLabel: 'Filas por página',
                  ofLabel: 'de',
                  pageLabel: 'páginas', // for 'pages' mode
                  allLabel: 'Todos',
                }"
              :select-options="{ enabled: true }"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                  <div align="center" class="history-amount">
                    <button class="btn btn-purple" @click="showDetail(props.row)">Detalle</button>
                  </div>
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <!-- <pre>
      {{tickets}}
    </pre> -->
    <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        :filename="`Labels-Order`"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="letter"
        :htmlToPdfOptions = "htmlToPdfOptions"
        pdf-orientation="portrait"
        pdf-content-width="100%"
        ref="html2Pdf"
      >
        <section slot="pdf-content">
          <section class="pdf-item labelsComplete">
            <div class="etiqueta col" v-for="(item, index) in tickets" :key="item.id_order">
              <div v-bind:class="[index > 2 ? 'row justify-content-center' : 'row justify-content-center']">
                <!-- <VueBarcode :value="item.barcode" format="Codabar"  textPosition="top" :options="barcode_option" height="30" width="2" font-size="10"/> -->
                <VueBarcode :value="item.barcode" format="CODE39"  textPosition="top" :options="barcode_option" height="35" width="1" font-size="9"/>
              </div>
              <div class="row justify-content-center printLabels">
                <div class="col-lg-10 text-left">
                  <p>{{item.key_client}} - {{item.name}} {{item.lastname}} {{item.lastname2}} </p>
                  <p>{{ item.key_provider + item.siglas}} - {{item.marca}} - {{item.modelo}} - {{item.color}} - {{item.numero}} </p>
                  <!-- <p class="endLabels"><b>{{item.sucursal}}</b> - Compra: {{item.date_buy}}</p> -->
                  <p class="endLabels">{{item.sucursal}}/{{ item.provider }}/{{item.date_buy}}</p>
                </div>
              </div>
            </div>
          </section>
        </section>
      </vue-html2pdf>

      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        :filename="`Labels-Order`"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        :htmlToPdfOptions = "htmlToPdfOptions"
        pdf-orientation="portrait"
        ref="buyReports"
      >
        <section slot="pdf-content" class="">
          <section class="parent" >
            <div class="div1"   v-for="(item, index) in tickets" :key="item.id_order">
              <div v-bind:class="[index > 2 ? 'row justify-content-center' : 'row justify-content-center']">
                <!-- <VueBarcode :value="item.barcode" format="Codabar"  textPosition="top" :options="barcode_option" height="30" width="2" font-size="10"/> -->
                <VueBarcode :value="item.barcode" format="CODE39"  textPosition="top" :options="barcode_option" height="35" width="1" font-size="9"/>
              </div>
              <div class="row justify-content-center printLabels">
                <div class="col-lg-10 text-left">
                  <p style="font-size: 6px;">{{item.key_client}} - {{item.name}} {{item.lastname}} {{item.lastname2}} &nbsp; &nbsp;{{ item.key_provider + item.siglas}} - {{item.modelo}} - {{item.color}} - {{item.numero}} </p>
                  <!-- <p class="endLabels"><b>{{item.sucursal}}</b> - Compra: {{item.date_buy}}</p> -->
                  <p class="endLabels">{{item.sucursal}}/{{ item.provider }}/{{item.date_buy}}</p>
                </div>
              </div>
            </div>
          <!-- <div class="parent" style="background: red;">
              <div class="div1">1</div>
               <div class="div1">2</div>
              <div class="div1">3</div>
              <div class="div1">4</div>
              <div class="div1">5</div>
              <div class="div1">6</div>
              <div class="div1">7</div>
              <div class="div1">8</div>
              <div class="div1">9</div>
              <div class="div1">10</div>
              <div class="div1">11</div>
              <div class="div1">12</div>
              <div class="div1">13</div>
              <div class="div1">14</div>
              <div class="div1">15</div>
              <div class="div1">16</div>
              <div class="div1">17</div>
              <div class="div1">18</div>
              <div class="div1">19</div>
              <div class="div1">21</div>
              <div class="div1">22</div>
              <div class="div1">23</div>
              <div class="div1">24</div>
              <div class="div1">25</div>
              <div class="div1">26</div>
              <div class="div1">27</div>
              <div class="div1">28</div>
              <div class="div1">29</div>
              <div class="div1">30</div>
              <div class="div1">31</div>
          </div> -->
          </section>
        </section>
      </vue-html2pdf>

  </div>
</template>

<script>
// import { BTable } from 'bootstrap-vue'
import getTimeFormat from '@/mixins/getTimeFormat'
import axiosAdelaService from '@/axios/axiosAdelaService'
import { mapGetters } from 'vuex'
import VueHtml2pdf from 'vue-html2pdf'
import VueBarcode from 'vue-barcode'
import moment from 'moment-timezone'
import { VueGoodTable } from 'vue-good-table'
import JsonExcel from 'vue-json-excel'

moment.tz('America/Mexico_City').format()
export default {
  mixins: [getTimeFormat],
  components: {
    // BTable,
    VueHtml2pdf,
    VueBarcode,
    VueGoodTable,
    JsonExcel
  },
  data () {
    return {
      tickets: [],
      isLoading: false,
      totalRecords: 0,
      barcode_option: {
        lineColor: '#0aa'
      },
      htmlToPdfOptions: {
        margin: [12, 0, 12, 0],
        filename: 'algo',
        html2canvas: {
          scale: 3,
          useCORS: true
        }
      },
      selectMode: 'multi',
      selected: [],
      dateI: moment().format('YYYY-MM-DD'),
      dateF: moment().format('YYYY-MM-DD'),
      items: [],
      columns: [
        {
          label: 'Folio',
          field: 'id_buy',
          type: 'number',
          filterOptions: {
            placeholder: 'ID del almacén',
            enabled: true,
            filterFn: this.columnFilterFn
          }
        },
        {
          label: 'Proveedor',
          field: 'provider',
          filterOptions: {
            placeholder: 'Nombre',
            enabled: true
          }
        },
        {
          label: 'Registro',
          field: 'name',
          filterOptions: {
            placeholder: 'Descripcion',
            enabled: true
          }
        },
        {
          label: 'Productos',
          field: 'quantity_products',
          filterOptions: {
            placeholder: 'Descripcion',
            enabled: true
          }
        },
        {
          label: 'Total compr',
          field: 'amount',
          filterOptions: {
            placeholder: 'Descripcion',
            enabled: true
          }
        },
        {
          label: 'Fecha de compra',
          field: 'date',
          filterOptions: {
            placeholder: 'Descripcion',
            enabled: true
          }
        },
        {
          label: 'Detalle',
          field: 'action'
        }
      ],
      fields: [
        { key: 'ticket', label: 'Folio', sortable: true, sortDirection: 'desc' },
        { key: 'provider', label: 'Proveedor', sortable: true, sortDirection: 'desc' },
        { key: 'name', label: 'Registro', sortable: true, sortDirection: 'desc' },
        { key: 'quantity_products', label: 'Productos', sortable: true, sortDirection: 'desc' },
        { key: 'amount', label: 'Total compra', sortable: true, sortDirection: 'desc' },
        { key: 'date', label: 'Fecha de compra' },
        { key: 'action', label: 'Detalle' }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 50,
      pageOptions: [50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    onRowSelected (items) {
      console.log('LLEGO', this.$refs['my-table'].selectedRows)
      this.selected = items.selectedRows
    },
    showDetail (row) {
      console.log(row)
      this.$router.push({ name: 'compras.detail', params: row })
    },
    getFormattedAmount (row) {
      if (row) {
        return this.$formatNumberCurrency(row.amount, 'MXN') + ' <span class="mxn">MXN</span>'
      } else {
        return ''
      }
    },
    async getCompras () {
      try {
        this.items = []
        const params = {
          fechaI: this.dateI,
          fechaF: this.dateF
        }
        console.log('parametros', params)
        const response = await axiosAdelaService.post('/getShopping', params)
        console.log('getShopping', response)
        if (response.status === 200) {
          this.items = response.data.rows
        }
      } catch (error) {
        this.showError('No se pudieron obtener el historial intentalo mas tarde.')
      }
    },
    async printEtiquetas () {
      try {
        this.tickets = []
        const params = {
          tickets: this.selected,
          enterprise: this.user.enterprise_id
        }
        console.log('parametros', params)
        const response = await axiosAdelaService.post('/searchTiketForBuys', params)
        console.log('GetBarcodesforTicket', response)
        if (response.status === 200) {
          const data = response.data
          for (const key in data) {
            for (const key2 in data[key]) {
              console.log('fecha de compra', moment(data[key][key2].date_buy).format('YYYY-MM-DD'))
              data[key].date_buy = moment(data[key][key2].date_buy).format('YYYY-MM-DD')
              this.tickets.push(data[key][key2])
            }
          }
          this.$refs.html2Pdf.generatePdf()
        }
      } catch (error) {
        this.showError('No se pudieron obtener el historial intentalo mas tarde.')
      }
    },
    async printEtiquetas2 () {
      try {
        this.tickets = []
        const params = {
          tickets: this.selected,
          enterprise: this.user.enterprise_id
        }
        console.log('parametros', params)
        const response = await axiosAdelaService.post('/searchTiketForBuys', params)
        console.log('GetBarcodesforTicket', response)
        if (response.status === 200) {
          const data = response.data
          for (const key in data) {
            for (const key2 in data[key]) {
              console.log('fecha de compra', moment(data[key][key2].date_buy).format('YYYY-MM-DD'))
              data[key].date_buy = moment(data[key][key2].date_buy).format('YYYY-MM-DD')
              this.tickets.push(data[key][key2])
            }
          }
          this.$refs.buyReports.generatePdf()
        }
      } catch (error) {
        this.showError('No se pudieron obtener el historial intentalo mas tarde.')
      }
    },
    updateParams (newProps) {
      this.serverParams = Object.assign({ page: 0 }, this.serverParams, newProps)
    },
    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      // this.getCompras()
    },
    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      // this.getCompras()
    },
    onSortChange (params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field
        }
      })
      // this.getCompras()
    },
    onColumnFilter (params) {
      console.log('onColumnFilter', params)
      this.updateParams(params)
      // this.getCompras()
    }
  },
  async mounted () {
    await this.getCompras()
  }
}
</script>
<style>
  .etiqueta {
    /* margin-top: 8px; */
    width: 50mm !important;
    height: 25mm !important;
    /* background: black;s */
    /* padding: 0px !important; */
    /* padding-left: 10; */
    margin-left: 38px;
    margin-top: 7px;
    /* display:grid; */
    /* background: red; */
    /* border: 1px solid; */
  }
  .labels {
    width: 60mm;
    font-size: 9px;
  }
  .labels p {
    line-height: 1;
    margin: 0;
  }
  .labelsComplete {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  /* grid-auto-rows: minmax(66mm, auto); */
  }
  .parent {
    display: grid;
    justify-content: center;
    align-items: center;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(10, 1fr);
    gap: 20px;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  .div1 {
    border: 1px solid;
    /* width: 50mm !important; */
    height: 22mm !important;
  }
  .content {
    display: grid;
    justify-content: center;
  }
</style>
